<template>
   <div class="">
    <router-link  :to="{name: 'bank-transactions-breakdown', query: {bankId: data.bankAccount.id}}" class="btn dealers_btn mr-3"  style="font-size: 15px">
        {{$t('text.clickButtons.view')}}
    </router-link> 
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
      
  },
  methods: {
      
      
  },
};

</script>